import React, { useState, useEffect, useRef } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface SearchInputProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  delay?: number;
  defaultValue?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  placeholder = "Search...",
  delay = 500,
  defaultValue = "",
}) => {
  const [searchValue, setSearchValue] = useState(defaultValue);
  const onSearchRef = useRef(onSearch);
  const isFirstRender = useRef(true);
  onSearchRef.current = onSearch;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      onSearchRef.current(searchValue);
    }, delay);

    return () => clearTimeout(timer);
  }, [searchValue, delay]);

  return (
    <Input
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      style={{ width: 300 }}
      allowClear
    />
  );
};

export default SearchInput;
